import type { DocTypeRepository } from "../repositories/doc-type-repository"

export const makeGetDocType = (repo: DocTypeRepository) => (id: string) =>
  repo.getById(id)
